import { useEffect } from 'react'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useDispatch, useSelector } from 'react-redux'
import useTranslation from '@/hooks/useTranslation'
import { setDashboardTitle } from '../../../redux/themeSlice'
import { queryNotifications } from '../../../redux/notificationSlice'

import { AppTable } from '@/components/shared-components'
import Layout from '../../../components/layout-components/dashboardLayout/Layout'
import Pagination from '../../../components/shared-components/Pagination'

const Notifications = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const router = useRouter()
  
  useEffect(() => {
    dispatch(setDashboardTitle('Notification'))
  }, [dispatch])

  const { notifications, pagination } = useSelector(
    (state) => state.notification
  )

  const columns = [
    {
      title: t('Title'),
      dataIndex: 'title',
    },
    {
      title: t('Body'),
      dataIndex: 'body',
      render: (text) => <span className='text-gray_300'>{text}</span>,
    },
    {
      title: t('Created At'),
      dataIndex: 'created_at',
      width: '10rem',
    },
  ]

  const { page } = router.query

  useEffect(() => {
    dispatch(queryNotifications(page))
  }, [dispatch, page])

  return (
    <>
      <Head>
        <title>Smartcaf</title>
        <link rel='icon' href='/favicon.ico' />
        <meta
          name='description'
          content='Evita le code, siamo il primo CAF in Italia completamente online!'
        />
      </Head>

      <div className='px-16 md:px-34 py-16 md:py-32'>
        <AppTable columns={columns} dataSource={notifications} />
        <Pagination
          current={pagination?.current}
          from={pagination?.from}
          to={pagination?.to}
          total={pagination?.total}
          last={pagination?.last}
        />
      </div>
    </>
  )
}

Notifications.Layout = Layout
export default Notifications
